import styled from 'styled-components/macro'

export const PagePadding = styled.main`
  position: relative;
  /* box-sizing: border-box */
  padding: 35px 24px;
  flex: 1;
  min-height: calc(100vh - 65px);
`
